import { UIOverlayViewStatus } from "common-ts/dist/models/UIOverlayViewStatus";

import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { resetUserMeasurementDraft } from "./MeasurementsRedux";

export enum OfflineActiveScreen {
    StandardBrowsing,
    SignUpStart,
    BenefitStart,
    SizePreset, // C1
    SizeSelect,
    BenefitMiddle,
    SizeLoading,
    SizeResult,
    ProductOption,
    AddressInput,
}

export interface OfflineStatusFlow {
    status: UIOverlayViewStatus;

    currentScreen: OfflineActiveScreen;
}

export const openOverlayCreateMeasWithInitialization = createAsyncThunk(
    "overlayOffline/openOverlayCreateMeasWithInitialization",
    async (
        payload, thunkAPI
    ) => {
        thunkAPI.dispatch(openOverlay());

        return null;
    }
);

export const closeOverlayAndResetWithCleanup = createAsyncThunk("overlayOffline/closeOverlayAndResetWithCleanup", async (payload, thunkAPI) => {
    thunkAPI.dispatch(closeOverlayAndReset());

    return null;
});

// Define the initial state using that type
const initialState: OfflineStatusFlow = {
    status: UIOverlayViewStatus.OffAndReady,

    currentScreen: OfflineActiveScreen.StandardBrowsing,
};

export const overlayOffline = createSlice({
    name: "overlayOffline",
    initialState,
    reducers: {
        closeOverlayAndReset: (state) => {
            state.status = UIOverlayViewStatus.OffAndReady;
            state.currentScreen = OfflineActiveScreen.StandardBrowsing;
        },

        openOverlay: (
            state
        ) => {
            state.status = UIOverlayViewStatus.On;
            state.currentScreen = OfflineActiveScreen.StandardBrowsing;
        },

        updateCurrentScreen: (state, action: PayloadAction<OfflineActiveScreen>) => {
            state.currentScreen = action.payload;
        },
    },
});

// Action creators are generated for each case reducer function
export const { closeOverlayAndReset, openOverlay, updateCurrentScreen } = overlayOffline.actions;

export default overlayOffline.reducer;
